const Footer = () => {
  return (
    <div className='footer'>
      <span>
        Made with{' '}
        <a href='https://github.com/kazvee/bestie-squad' rel='nofollow'>
          <img
            width='24'
            height='24'
            src='https://img.icons8.com/doodle/48/stitched-heart.png'
            alt='GitHub repository'
          />
        </a>{' '}
        and:
      </span>
      <span>
        <a
          href='https://www.favicon.cc/?action=icon&file_id=996246'
          rel='nofollow'
        >
          Favicon
        </a>{' '}
        by{' '}
        <a
          href='https://www.favicon.cc/?action=icon_list&user_id=673951'
          rel='nofollow'
        >
          unsureamen
        </a>
      </span>
      <span>
        <a
          href='https://www.freepik.com/free-vector/gradient-pastel-sky-background_13326145.htm'
          rel='nofollow'
        >
          Background image
        </a>{' '}
        by{' '}
        <a href='https://www.freepik.com' rel='nofollow'>
          Freepik
        </a>
      </span>
      <span>
        <a href='https://icons8.com/icon/81747/heart' rel='nofollow'>
          Heart
        </a>{' '}
        &{' '}
        <a href='https://icons8.com/icon/80705/add' rel='nofollow'>
          Add
        </a>{' '}
        &{' '}
        <a
          href='https://icons8.com/icon/5mPDN05hVihb/sylvanian-families'
          rel='nofollow'
        >
          Squad
        </a>{' '}
        icons by{' '}
        <a href='https://icons8.com/' rel='nofollow'>
          Icons8
        </a>
      </span>
    </div>
  );
};

export default Footer;
